var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSort(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9821 33.1928C16.2842 32.6162 16.8813 32.255 17.5322 32.255H38.5322C39.1831 32.255 39.7803 32.6162 40.0823 33.1928C40.3844 33.7693 40.3416 34.4659 39.9711 35.0011L29.4711 50.1677C29.1442 50.6399 28.6065 50.9216 28.0322 50.9216C27.458 50.9216 26.9203 50.6399 26.5934 50.1677L16.0934 35.0011C15.7229 34.4659 15.68 33.7693 15.9821 33.1928ZM20.8722 35.755L28.0322 46.0972L35.1922 35.755H20.8722Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0322 5.42163C28.6065 5.42163 29.1442 5.70337 29.4711 6.17551L39.9711 21.3422C40.3416 21.8773 40.3844 22.5739 40.0823 23.1505C39.7803 23.727 39.1831 24.0883 38.5322 24.0883H17.5322C16.8813 24.0883 16.2842 23.727 15.9821 23.1505C15.68 22.5739 15.7229 21.8773 16.0934 21.3422L26.5934 6.17551C26.9203 5.70337 27.458 5.42163 28.0322 5.42163ZM20.8722 20.5883H35.1922L28.0322 10.2461L20.8722 20.5883Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.3726c544.svg";
export { ForwardRef as ReactComponent };